import classnames from 'classnames/dedupe';

import { getCursorClass } from 'Components/utils/form/form.util';

const DEFAULT_SIZES = {
  small: 32,
  medium: 42,
  large: 52,
};

export const themes = {
  default: props => {
    const {
      isActive,
      isDisabled,
      isFilled,
      isReadOnly,
      size = 'medium',
      validationState = 'NOT_VALIDATED',
    } = props;

    const hasDefaultStyle =
      validationState === 'NOT_VALIDATED' && !isActive && !isFilled && !isDisabled;
    const hasActiveStyle =
      validationState === 'NOT_VALIDATED' && isActive && !isDisabled && !isFilled;
    const hasValidStyle = validationState === 'IS_VALID' && !isFilled && !isDisabled;
    const hasInvalidStyle = validationState === 'IS_INVALID' && !isFilled && !isDisabled;
    const hasFilledStyle = isFilled && !isDisabled;

    const iconTheme = classnames('flex items-center justify-center', {
      'text-current': !hasFilledStyle,
      'text-gray-medium': isDisabled,
    });

    return {
      thLabel: classnames('block font-bold pb-1 text-md transition-color', {
        'text-gray-darker': validationState === 'NOT_VALIDATED',
        'text-emerald': validationState === 'IS_VALID' && !isDisabled,
        'text-red': validationState === 'IS_INVALID' && !isDisabled,
      }),
      thField: classnames(
        'border-1 flex outline-custom px-3 relative rounded-tiny transition-colors',
        getCursorClass(props),
        {
          'button-medium': size === 'medium',
          'button-default': size === 'large',
          'bg-gray-lighter border-gray-lighter': isDisabled,
          'bg-white border-gray-medium': hasDefaultStyle,
          'focus-within:border-blue text-gray-darker focus-within:text-blue':
            hasDefaultStyle && !isReadOnly,
          'bg-white border-blue text-blue': hasActiveStyle,
          'bg-white border-emerald': hasValidStyle,
          'bg-white border-red': hasInvalidStyle,
          'bg-blue border-blue text-white': hasFilledStyle,
        },
      ),
      thFieldStyle: { height: DEFAULT_SIZES[size] },
      thIconLeft: classnames(iconTheme, 'rtl:pr-3'),
      thIconRight: classnames(iconTheme, 'rtl:pl-3'),
      thInput: 'flex flex-1 relative',
      thLoader: 'flex items-center justify-center leading-none rtl:pl-3',
      thSpinnerColor: hasFilledStyle ? 'current' : 'blue',
      thClearButton: classnames('reset-button leading-none rtl:pl-3 transition-color', {
        'text-gray-medium': !hasFilledStyle,
        'text-current': hasFilledStyle,
      }),
      thClearIconSize: '0.625rem',
      thNotes: 'mt-px pt-px text-sm text-gray-medium',
    };
  },
};
